<template>
  <div>
    <keep-alive>
      <router-view />
    </keep-alive>
  </div>
</template>

<script>
  export default {
    name: "keep-alive-box"
  }
</script>

<style scoped>

</style>